module.exports = function (fox, staticUrl) {
	'use strict';

	if (staticUrl) {
		__webpack_public_path__ = __webpack_public_path__.replace(/.*\/dist\/+/, staticUrl + (staticUrl.slice(-1) === '/' ? '' : '/'));
	}

	require("../../../root/__main_entry.tmp.js")(fox);

	function getDeps (context) {
		context.keys().forEach(function (m) {
			var module = context(m);
			if (typeof module === "function") {
				module(fox, __webpack_require__.p);
			}
		});
	}
	
	require('./stylus/_autumn-new-index.styl');

	var contexts = [];
	contexts.push(require.context("./dependencies", true, /(\/|\\)(?!_)[\w\.\-\\]+\.js$/));
	contexts.push(require.context("./options", true, /(\/|\\)(?!_)[\w\.\-\\]+\.(opt|js)$/));
	contexts.push(require.context("fox-dynamic-injection!fox-template-loader?interpolate!./templates", true, /(\/|\\)(?!_)[\w\.\-\\]+\.tpl$/));
	contexts.push(require.context("./widget", true, /(\/|\\)(?!_)[\w\.\-\\]+\.js$/));
	contexts.forEach(getDeps);
	
	var switchColorScheme = fox.switchColorScheme = require('../../../utils/switch-colorscheme')(function (value) {
		return require('!!file?name=[path][name].[sha512:hash:base64:7].css!fox-colorsheme-res-resolver!stylus!../colorscheme/_' + value + '.styl');
	});

	var colorscheme = fox.getEnv('c11n.invoker.colorscheme.value');

	return switchColorScheme(colorscheme || 'default');
};


//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 82
// module chunks = 4